var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('home-menu'),_vm._v(" "),_c('announcement'),_vm._v(" "),_c('news'),_vm._v(" "),_c('cartableGrid')],1)}
var staticRenderFns = []

export { render, staticRenderFns }